import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { programmesApi } from '../api/programmes.api'
import type { CreateProgrammeRequest, UpdateProgrammeRequest } from '@/shared/types/admin'

const PROGRAMMES_KEY = ['programmes']

export function useProgrammes() {
  return useQuery({
    queryKey: PROGRAMMES_KEY,
    queryFn: programmesApi.getAll,
    select: (data) => [...data].sort((a, b) => a.libelle.localeCompare(b.libelle)),
  })
}

export function useProgramme(id: number | undefined) {
  return useQuery({
    queryKey: [...PROGRAMMES_KEY, id],
    queryFn: () => programmesApi.getById(id!),
    enabled: !!id,
  })
}

export function useCreateProgramme() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateProgrammeRequest) => programmesApi.create(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PROGRAMMES_KEY }),
  })
}

export function useUpdateProgramme() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateProgrammeRequest }) =>
      programmesApi.update(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PROGRAMMES_KEY }),
  })
}

export function useDeleteProgramme() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => programmesApi.delete(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PROGRAMMES_KEY }),
  })
}
